<template>
  <div>
    <b-modal id="share_modal" title="Share to web" class="theme-modal" hide-footer
             no-close-on-backdrop>
      <div>
        <div class="media">
          <label class="col-form-label m-r-10">Share</label>
          <div class="media-body text-right switch-sm">
            <label class="switch">
              <input v-model="isShared" type="checkbox"><span class="switch-state"></span>
            </label>
          </div>
        </div>

        <div class="clipboaard-container p-relative p-2">

          <div class="copy-overlay" v-show="!isShared"></div>

          <b-form-input readonly placeholder="Share link" ref="text"></b-form-input>
          <div class="mt-3">
            <b-button variant="primary" @click="" class="mr-1"><i class="fa fa-copy"></i> Copy</b-button>
            <b-button variant="danger" style="float: right" @click="" class="mr-1"><i class="fa fa-refresh"></i> Refresh link</b-button>
          </div>

        </div>

      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'ShareModal',
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      isShared: false
    };
  },
  methods: {
    openModal() {
      this.$bvModal.show('share_modal')
    },
    publish() {
      this.$store.dispatch('projects/share', {
        id: this.project.id
      })
    }
  },
  computed: {
    // locale: function () {
    //   return this.$i18n.locale
    // },
    // title: function () {
    //   return this.section.translation[this.locale] ? this.section.translation[this.locale].name : this.section.translation['en'].name
    // }
  }
};
</script>

<style>
.copy-overlay {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  border: 1px solid #dee2e6;
  background-color: rgba(115, 102, 255, 0.06);
  border-radius: calc(0.3rem - 1px);
}
</style>